let swipers = {
    contentSlider: {
        slider: false,
        elem: $('.js-article-content-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            centerInsufficientSlides: true,
            pagination: {
                el: '.js-article-content-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-article-content-slider-next',
                prevEl: '.js-article-content-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.contentSlider.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    }
}

Event.on('Window.resized', function() {
    checkSliders(swipers);
});

function repositionPager(data) {
    const $buttons = $('.blog-pager__buttons');
    let itemsCount = data ? data.current : $('.c-listing--articles').children().length;

    if (itemsCount % 2) {
        $buttons.addClass('is-odd');
    } else {
        $buttons.removeClass('is-odd');
    }
}

Event.on('Listing.fetchedData', (data) => {
    repositionPager(data);

    $('.c-listing').removeClass('is-loading');
});

repositionPager();

$(function() {
    repositionPager();
    checkSliders(swipers);

    floatingBoxInit({
        box: '.js-floating-box',
        wrapper: '.js-floating-box-wrapper',
        query: 'sm;md;lg'
    });

    $('.blog').on('click', '.pager__item > a', function(e) {
        const $pagerButton = $(this);

        if ($pagerButton.hasClass('is-disabled')) {
            return false;
        }

        $pagerButton.addClass('is-loading');
        $('.c-listing').addClass('is-loading');
        $('.js-pager-button').addClass('is-disabled');

        if ($(window).scrollTop() > $('.blog').offset().top) {
            $('.blog').slideHere(20, 300);
        }
    });

    $(".js-blog-detail-gallery").lightGallery({
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false,
        selector: ".js-lightbox",
        galleryId: 1
    });

    $(".js-blog-detail-gallery-more").on("click", e => {
        e.preventDefault();

        $(".js-lightbox").eq(5).click();
    });
});